<script>
  import { CircleIcon } from 'vue-feather-icons'

  export default {
    components: { CircleIcon },
    props: {
      label: {
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      isCollapsed: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        collapse: false,
      }
    },
    created(){
      if (this.isCollapsed){
        this.collapse = true
      }
    },
  }
</script>

<template>
  <div class="tree-collapse">
    <div
      v-fabric-collapse="`collapse-${name}`"
      class="
        tree-collapse-header btn-collapse
        tw-px-1 tw-py-2
        tw-flex !tw-items-center tw-justify-between
        !tw-rounded-none md:!tw-rounded-r
        !tw-w-full md:!tw-w-fit">
      <article class="tw-flex tw-flex-row tw-items-center">
        <CircleIcon size="12" class="tw-ml-3 tw-mr-2" />
        <slot name="label" />
      </article>
      <article class="tw-flex tw-flex-row tw-items-center tw-pr-2">
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!collapse"
          :duration="500"
          :default-collapsed="!collapse"
        />
      </article>
    </div>
    <FabricCollapse
      :id="'collapse-' + name"
      v-model="collapse"
      hide-header
      :duration="500"
      class="info-detail"
      :default-shown="!collapse">
      <slot />
    </FabricCollapse>
  </div>
</template>
